module.exports = __webpack_public_path__ + "static/search-recipes-f61d62c9b21c558dd7f8e5d7e653392b.mp4";